var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _path15, _circle, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnCorrectPalm3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.491 28.62c-.49-10.245-8.873-18.423-19.11-18.423-10.238 0-18.621 8.181-19.111 18.422H45.49z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.02 41.419c3.6-2.7 2.7-9 2.7-13.5l-4.05-3.6-11.25-1.35-13.95.45c-2.25-.15-6.75.63-6.75 4.95 0 5.4 2.25 5.85 11.7 12.6s18 3.15 21.6.45z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.187 48.115 4.017-19.847c1.09-.85 3.623-2.022 5.03.1 1.759 2.651 2.021 3.623 1.129 8.033l-1.964 9.703c-.892 4.411-4.778 5.461-6.542 5.104-1.765-.357-2.027-1.328-1.67-3.093z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.076 28.566a1 1 0 0 0-1.96-.397l1.96.397zm6.74 8.144a1 1 0 1 0-1.94-.486l1.94.486zm-8.7-8.541c-.611 3.017-1.517 7.604-2.306 11.611-.79 4.012-1.46 7.436-1.603 8.138l1.96.397c.144-.709.817-4.145 1.605-8.149.79-4.008 1.694-8.59 2.304-11.6l-1.96-.397zm-3.909 19.75c-.183.906-.276 1.876.117 2.701.434.913 1.304 1.361 2.335 1.57l.397-1.96c-.734-.15-.877-.365-.926-.469-.09-.19-.136-.588.038-1.446l-1.96-.397zm2.452 4.27c1.149.233 2.811-.001 4.304-.882 1.537-.907 2.912-2.507 3.417-5.003l-1.96-.397c-.388 1.915-1.402 3.045-2.473 3.677-1.114.657-2.276.77-2.891.645l-.397 1.96zm7.72-5.885c.71-3.506 1.967-7.716 2.437-9.594l-1.94-.486c-.431 1.722-1.738 6.133-2.457 9.683l1.96.397z",
    fill: "#DEE5F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.679 65.08c.249-1.782 2.166-19.613 2.617-29.513.082-.594 2.598-2.019 5.807-1.571 4.011.56 2.125 7.566 1.69 10.686L19.748 66.52c-.249 1.783-1.835 3.38-4.063 3.069-2.228-.311-3.317-2.28-3.006-4.509z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.846 36.468c.45 7.2-1.918 26.83-2.167 28.612-.31 2.229.778 4.198 3.006 4.509 2.229.31 3.815-1.286 4.063-3.069.2-1.426 1.816-15.717 2.748-22.402",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.67 69.317v-25.2c0-1.65.63-4.95 3.15-4.95 3.15 0 4.05 2.7 4.05 5.4v25.2c0 3.15-2.7 3.6-3.6 3.6-.9 0-3.6-.9-3.6-4.05z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.67 44.117v25.2c0 3.15 2.7 4.05 3.6 4.05.9 0 3.6-.45 3.6-3.6v-25.65",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.903 65.62 30.582 44.6c-.445-4.026 1.196-5.565 3.432-5.812 2.237-.247 3.677.5 4.171 4.972l2.322 21.022c.296 2.684-.848 4.621-3.084 4.868-2.237.247-4.174-.897-4.52-4.028z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.145 44.117c.658 5.964 2.482 19 2.758 21.504.346 3.13 2.283 4.275 4.52 4.028 2.236-.247 3.38-2.184 3.084-4.868L38.185 43.76",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m41.984 56.445-3.093-12.214c-.884-3.49-1.878-7.416 1.501-8.736 2.704-1.056 4.116 1.588 4.484 3.042l4.199 16.577c.442 1.745-.425 3.821-2.606 4.373-2.181.553-3.932-.86-4.485-3.042z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.245 43.667c1.326 5.235 3.187 10.597 3.74 12.778.552 2.181 2.303 3.595 4.484 3.042 2.18-.552 3.048-2.628 2.606-4.373l-4.199-16.577",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.381 11.975c9.274 0 16.934 7.403 17.428 16.659h1.746c-.49-10.244-8.937-18.437-19.174-18.437S7.686 18.577 7.196 28.818h1.756c.484-9.266 8.156-16.843 17.43-16.843z",
    fill: "#DEE5F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.72 28.369v9.856",
    stroke: "#DEE5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.717,
    y: 2.998,
    width: 48.181,
    height: 81,
    rx: 6,
    stroke: "#9BACD7",
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.717 75.27h48.18v2.728a6 6 0 0 1-6 6H8.718a6 6 0 0 1-6-6v-2.729zM2.717 7.537a4.539 4.539 0 0 1 4.539-4.539h39.103a4.539 4.539 0 0 1 4.539 4.539H2.717z",
    fill: "#9BACD7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.633,
    cy: 80.159,
    r: 2.444,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5758",
    d: "m41.645 58.875 3.326-3.61 16.242 14.968-3.326 3.61z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5758",
    d: "m57.502 55.01 3.47 3.47-15.617 15.618-3.47-3.47z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCorrectPalm3);
export default __webpack_public_path__ + "static/media/un-correct-palm-3.d8f29e87cc78fed4da4ca8cf2d9cedc8.svg";
export { ForwardRef as ReactComponent };